var map = {
	"./checkmark.svg": "ef46",
	"./games.svg": "9185",
	"./group.svg": "9076",
	"./medal.svg": "f33e",
	"./shield.svg": "8ebb",
	"./store.svg": "1b79",
	"./telegram.svg": "32fe",
	"./vk.svg": "d1e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "790f";